import gql from 'graphql-tag';

export const PurchasedCustomPrintOrderSummaryFields = gql`
  fragment PurchasedCustomPrintOrderSummaryFields on PurchasedCustomPrint {
    id
    name
    quantity
    order_status
    account {
      id
      name
      email_address
      phone_number
    }
    transaction {
      id
      email_address
    }
    custom_print {
      id
      name
      description
    }
    transaction_item {
      __typename
      ... on ITransactionItem {
        id
        print_product_configurations {
          records {
            id
            quantity
            front_print_file_url
            print_product_configuration {
              id
              name
            }
            account_card {
              id
              front_preview_file_url
            }
          }
        }
      }
      ... on ITransactionCustomPrintItem {
        custom_print_name
      }
      ... on TransactionPhotoPrintPackageItem {
        print_package_name
        print_items {
          records {
            id
            quantity
            print_package_item_type_name
          }
        }
      }
      ... on TransactionPhotoPrintItem {
        photo_print_size_name
      }
      ... on TransactionPhotoPhotoPricingItem {
        photo_pricing_name
        print_items {
          records {
            id
            quantity
            print_package_item_type_name
          }
        }
      }
    }
    album {
      id
      name
    }
  }
`;
